import { useMutation } from '@tanstack/react-query';
import { ApiRoutes } from 'src/common/api/ApiRoutes';
import { useAxiosSocket } from 'src/common/api/AxiosContext';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { useUserInfoState } from '../states/useUserInfoState';

export const useSocketSelectSeatMutation = (channel: string) => {
  const axios = useAxiosSocket();
  const { userInfo } = useUserInfoState();

  const handleFetch = (itemId: string) => {
    const payload = {
      payload: {
        itemId,
        userId: userInfo?.id,
      },
      item_id: itemId,
      broadcast: {
        channel,
        event: 'seat_selected',
      },
    };
    return axios.post(ApiRoutes.selectSeat, payload);
    // return axios.get<AxiosResponse<SocketSessionProps>>(`healthz`, {});
  };

  return useMutation(handleFetch, {
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
  });
};
export const useSocketSeatSelectedMutation = (channel: string) => {
  const axios = useAxiosSocket();
  const { userInfo } = useUserInfoState();

  const handleFetch = (itemId: string) => {
    const payload = {
      payload: {
        item_id: itemId,
        user_id: userInfo?.id,
        operator: {
          id: 1,
          image: '',
          name: 'hi',
          rating: 3,
        },
        from_location: 'PP',
        to_location: 'SR',
        trip_id: '1',
      },
      item_id: itemId,
      broadcast: {
        channel,
        event: 'seat_already_selected',
      },
    };
    return axios.post(ApiRoutes.selectSeat, payload);
    // return axios.get<AxiosResponse<SocketSessionProps>>(`healthz`, {});
  };

  return useMutation(handleFetch, {
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
  });
};
